import { useKeycloak } from '@react-keycloak/web';
import PropTypes from 'prop-types';
import User from '../../models/user';
import API from '../../services/api';
import AccessDenied from '../../views/Main/components/Access/AccessDenied.jsx'; // Importa el componente

const ProtectedRoute = ({ children, allowedCompanies }) => {
    const { keycloak, initialized } = useKeycloak();
    const user = initialized && keycloak.authenticated ? new User(keycloak.token, keycloak.tokenParsed) : null;

    if (!initialized) {
        return <div>Cargando...</div>; // Puedes personalizar el indicador de carga
    }

    if (!keycloak.authenticated) {
        keycloak.login();
        return null; // Evita renderizar nada más mientras se redirige al login
    }

    // Interceptors para agregar token y manejar 401 (se mantienen)
    if (keycloak?.token) {
        API.interceptors.request.use(
            (config) => {
                config.headers['Authorization'] = `Bearer ${keycloak.token}`;
                return config;
            },
            (error) => Promise.reject(error)
        );

        API.interceptors.response.use(
            (response) => {
                return response;
            },
            (error) => {
                if (error.response && error.response.status === 401) {
                    keycloak.logout();
                }
                return Promise.reject(error);
            }
        );
    }

    // Comprobación de permisos por compañía
    if (allowedCompanies && allowedCompanies.length > 0 && user && !allowedCompanies.includes(user.company)) {
        return <AccessDenied />; // Renderiza el componente AccessDenied
    }

    return children;
};

ProtectedRoute.propTypes = {
    children: PropTypes.any.isRequired,
    allowedCompanies: PropTypes.arrayOf(PropTypes.string), // Nuevo prop para especificar las compañías permitidas
};

export default ProtectedRoute;